import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { TeamComponent } from '../team/team.component';
import { ScheduleService } from '../schedule/schedule.service';
import { CoreService } from '../core.service';
import { Game, MediaEvent, Flavor } from '../app.models';
import { tzDatePipe } from '../app.pipes';
import { getLogoSrcOf, inplaceKeySort } from '../app.utils';
import { PlayerService } from '../tvbox/player.service';


@Component({
	selector: 'app-timemachine',
	imports: [
		CommonModule,
		FormsModule,
		tzDatePipe,

		TeamComponent,
	],
	templateUrl: './timemachine.component.html',
	styleUrl: './timemachine.component.scss',
})
export class TimemachineComponent {
	constructor(
		public core: CoreService,
		public schedule: ScheduleService,
		public player: PlayerService,
	){}
	getLogoSrcOf = getLogoSrcOf;

	media_events: Record<number, MediaEvent> = {};
	games: Record<number, Game> = {};
	flavors: Record<string, Flavor> = {};

	media_events_list: MediaEvent[] = [];
	flavors_list: Flavor[] = [];
	selected_date: Date;

	ngOnInit(){
		this.media_events_list = [];
		this.games = {};
		this.media_events = {};
		this.flavors = {};
		this.flavors_list = [];

		for( let g of this.core.games )
			this.games[g.id] = g;

		for( let f of this.core.flavors ){
			this.flavors[f.id] = f;
			this.flavors_list.push(f);
		}

		for( let me of this.core.media_events ){
			if( !me['datetime'] ) continue //Make sure it's not a 24/7 or something
			this.media_events[me.id] = me;
			this.media_events_list.push( me )
		}
		inplaceKeySort( this.media_events_list, (me) => [me.datetime, me.game_id, me.order] );
	}

	async load_date(){

		let response = await this.core.json_request(
			"POST", "/api/v1/source/query_media_events",
			{
				"date":this.selected_date,
				"tz_offset_milliseconds": this.schedule.tz_offset_milliseconds,
			}
		);
		if( !response.ok ) return;

		let timestamp = (new Date()).getTime();
		this.media_events_list = [];
		this.games = {};
		this.media_events = {};

		for( let g of response.json['games'] )
			Game.update_or_create( g, timestamp, this.games );

		for( let f of response.json['flavors'] )
			Flavor.update_or_create( f, timestamp, this.flavors );

		for( let me of response.json['media_events'] ){
			if( !me['datetime'] ) continue //Make sure it's not a 24/7 or something
			if( me['status'] == "S" ) continue //Don't show scrapped!

			let model = MediaEvent.update_or_create( me, timestamp, this.media_events );
			this.media_events_list.push( model )
		}
		inplaceKeySort( this.media_events_list, (me) => [me.datetime, me.game_id, me.order] );
	}
}
